module.exports = __webpack_public_path__ + "img/act.2a9387de.svg";